module.exports = __webpack_public_path__ + "static/media/p-1.96450751.png";